<template>
  <template v-if="sidebarComponents.length === 0">
    <section
      v-if="variant === variants.v1"
      class="layout-pt-lg layout-pb-lg"
      :style="`background-color: var(--c-${vars.backgroundColor}, var(--c-section_primary))`"
    >
      <div class="container">
        <!-- Header -->
        <div class="row justify-between items-center tw-gap-5">
          <!-- Başlık -->
          <div class="col-auto" v-html="vars.titleHtml"></div>
          <div class="col-auto tw-hidden tw-items-center tw-space-x-4 md:tw-flex">
            <nuxt-link
              v-for="(btn, idx) in buttons"
              :key="idx"
              :to="btn.button_link"
              :class="[buttons.length > 1 ? 'tw-w-full md:tw-w-auto' : 'tw-w-auto', `n-${btn.button_type}`]"
              :external="true"
            >
              {{ btn.button_label }}
            </nuxt-link>
          </div>
        </div>

        <!-- Slider -->
        <div
          class="relative mt-60 md:mt-40 sm:mt-20 js-section-slider"
          data-gap="30"
          data-slider-cols="xl-4 lg-3 md-2 sm-2 base-1"
        >
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(card, index) in cards" :key="index">
              <div class="imageCard -type-2 tw-cursor-pointer" @click.prevent="handleCardClick(card)">
                <div>
                  <library-image :src="card.photo" :w-ratio="350" :h-ratio="622" :alt="card.title" />
                </div>
                <div class="tw-h-[80px]">
                  <h5 class="imageCard__title tw-line-clamp-2">{{ card.title }}</h5>
                </div>
                <div class="mt-4">
                  <div class="mt-4">
                    <div class="mt-4" v-if="card.button_label">
                      <button
                        v-if="card.button_label"
                        @click.stop="handleButtonClick(card)"
                        :class="`n-${card.button_type}`"
                      >
                        {{ card.button_label }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Navigation Arrows -->
          <div class="d-flex mt-60 md:mt-30 min-[1200px]:!tw-hidden">
            <button
              class="sliderNav -prev js-prev n-link !tw-bg-transparent"
              style="border-color: var(--c-primary) !important"
            >
              <i class="icon-left-arrow"></i>
            </button>
            <button
              style="border-color: var(--c-primary) !important"
              class="sliderNav -next ml-20 js-next n-link !tw-bg-transparent"
            >
              <i class="icon-right-arrow"></i>
            </button>
          </div>

          <!-- Mobile Buttons -->
          <div class="col-auto tw-mt-8 tw-flex tw-items-center md:tw-hidden">
            <nuxt-link
              v-for="(button, idx) in buttons"
              :key="idx"
              :to="button.button_link"
              :class="[buttons.length > 1 ? 'tw-w-full md:tw-w-auto' : 'tw-w-auto', `n-${button.button_type}`]"
              :external="true"
            >
              {{ button.button_label }}
            </nuxt-link>
          </div>
        </div>

        <!-- Popup -->
        <popup v-if="selectedCard && popupConfig.isActive" :config="popupConfig" custom-width="90%">
          <template #content>
            <library-form
              v-if="selectedCard.formData"
              :form="selectedCard.formData"
              version="v2"
              :component="component"
            />
          </template>
        </popup>
      </div>
    </section>

    <section
      v-if="variants.v2 === variant"
      class="layout-pt-lg layout-pb-lg"
      :style="`background-color: var(--c-${vars.backgroundColor}, var(--c-section_primary))`"
    >
      <div class="container">
        <!-- Header -->
        <div class="row justify-between items-center">
          <!-- Başlık -->
          <div class="col-auto" v-html="vars.titleHtml"></div>
          <div class="col-auto tw-hidden tw-items-center tw-space-x-4 md:tw-flex">
            <nuxt-link
              v-for="(btn, idx) in buttons"
              :key="idx"
              :to="btn.button_link"
              :class="[buttons.length > 1 ? 'tw-w-full md:tw-w-auto' : 'tw-w-auto', `n-${btn.button_type}`]"
              :external="true"
            >
              {{ btn.button_label }}
            </nuxt-link>
          </div>
        </div>

        <!-- Slider -->
        <div
          class="relative mt-60 md:mt-40 sm:mt-20 js-section-slider"
          data-gap="30"
          data-slider-cols="xl-4 lg-3 md-2 sm-2 base-1"
        >
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(card, index) in cards" :key="index">
              <div class="imageCard -type-2 cursor-pointer" @click.prevent="handleCardClick(card)">
                <div>
                  <library-image :src="card.photo" :w-ratio="350" :h-ratio="622" :alt="card.title" />
                </div>
                <div class="tw-h-[80px]">
                  <h5 class="imageCard__title tw-line-clamp-2">{{ card.title }}</h5>
                </div>
                <div class="mt-4">
                  <div class="mt-4">
                    <div class="mt-4" v-if="card.button_label"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Navigation Arrows -->
          <div class="d-flex mt-60 md:mt-30 min-[1200px]:!tw-hidden">
            <button class="sliderNav -prev js-prev n-link !tw-bg-transparent" style="border-color: #1b3b47 !important">
              <i class="icon-left-arrow"></i>
            </button>
            <button
              style="border-color: #1b3b47 !important"
              class="sliderNav -next ml-20 js-next n-link !tw-bg-transparent"
            >
              <i class="icon-right-arrow"></i>
            </button>
          </div>

          <!-- Mobile Buttons -->
          <div class="col-auto tw-mt-8 tw-flex tw-items-center md:tw-hidden">
            <nuxt-link
              v-for="(button, idx) in buttons"
              :key="idx"
              :to="button.button_link"
              :class="[buttons.length > 1 ? 'tw-w-full md:tw-w-auto' : 'tw-w-auto', `n-${button.button_type}`]"
              :external="true"
            >
              {{ button.button_label }}
            </nuxt-link>
          </div>
        </div>

        <!-- Popup -->
        <popup v-if="selectedCard && popupConfig.isActive" :config="popupConfig" custom-width="90%">
          <template #content>
            <library-form
              v-if="selectedCard.formData"
              :form="selectedCard.formData"
              version="v2"
              :component="component"
            />
          </template>
        </popup>
      </div>
    </section>
  </template>

  <template v-else-if="sidebarComponents.length > 0">
    <div
      class="tw-px-4 tw-py-9"
      :style="`background-color: var(--c-${vars.backgroundColor}, var(--c-section_primary)); border-radius: var(--rounded); border: 1px solid var(--c-border);`"
    >
      <h4 v-html="vars.titleHtml"></h4>

      <div class="tw-relative tw-mt-10 tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-10">
        <div class="relative js-section-slider" data-gap="30" data-slider-cols="xl-1 lg-1 md-1 sm-1 base-1">
          <Swiper
            :key="'guide-swiper-' + cards.length"
            :modules="swiperModules"
            :pagination="false"
            :slides-per-view="1"
            :space-between="20"
            effect="fade"
            :clickable="true"
            :watch-overflow="true"
            :loop="true"
            @slideChange="onSlideChange"
            @swiper="onSwiper"
            class="tw-w-full"
          >
            <SwiperSlide v-for="(card, index) in cards" :key="`ourguide-${index}`">
              <div class="imageCard -type-2 cursor-pointer" @click.prevent="handleCardClick(card)">
                <div>
                  <library-image :src="card.photo" :w-ratio="350" :h-ratio="622" :alt="card.title" />
                </div>
                <h5 class="imageCard__title">{{ card.title }}</h5>

                <div class="mt-4" v-if="card.button_label">
                  <template v-if="vars.cardVersionText !== 'v2'">
                  <button type="button" @click.stop="handleButtonClick(card)" :class="`n-${card.button_type}`">
                    {{ card.button_label }}
                  </button>
                </template>
                <template v-else-if="vars.cardVersionText === 'v2'">
                  <button type="button" @click.stop="handleButtonClick(card)" class="n-link" :class="`n-${card.button_type}`">
                    {{ card.button_label }}
                    <svg width="23" height="9" viewBox="0 0 23 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.3536 4.85355C22.5488 4.65829 22.5488 4.34171 22.3536 4.14645L19.1716 0.964466C18.9763 0.769204 18.6597 0.769204 18.4645 0.964466C18.2692 1.15973 18.2692 1.47631 18.4645 1.67157L21.2929 4.5L18.4645 7.32843C18.2692 7.52369 18.2692 7.84027 18.4645 8.03553C18.6597 8.2308 18.9763 8.2308 19.1716 8.03553L22.3536 4.85355ZM0 4.5V5H22V4.5V4H0V4.5Z" fill="var(--c-primary)"/></svg>
                  </button>
                </template>
                
                </div>
              </div>
            </SwiperSlide>
          </Swiper>

          <div v-if="cards.length > 1" class="d-flex mt-60 md:mt-30 max-lg:tw-items-center max-lg:tw-justify-center">
            <button class="sliderNav -prev n-link" @click="slidePrev">
              <i class="icon-left-arrow"></i>
            </button>
            <button class="sliderNav -next ml-20 n-link" @click="slideNext">
              <i class="icon-right-arrow"></i>
            </button>
          </div>
        </div>

        <!-- Popup -->
        <popup v-if="selectedCard && popupConfig.isActive" :config="popupConfig" custom-width="90%">
          <template #content>
            <h3 class="tw-col-span-12 tw-pb-2">{{ selectedCard.title }}</h3>
            <library-form
              v-if="selectedCard.formData"
              :form="selectedCard.formData"
              version="v2"
              :is-form-name-visible="false"
              :component="component"
            />
          </template>
        </popup>
      </div>
    </div>
  </template>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { useWebsiteStore } from '~/units/website/store';
import Popup from '~/components/common/popup/Popup.vue';
import { mapStores } from 'pinia';
import { Pagination as SwiperPagination } from 'swiper/modules';

export default defineNuxtComponent({
  name: 'CustomSliderWithPopup',
  mixins: [ComponentMixin],
  components: { Popup },

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      selectedCard: null,
      popupConfig: { isActive: false },
      swiperModules: [SwiperPagination],
    };
  },

  mounted() {
    this.onSlideChange();
  },

  computed: {
    ...mapStores(useWebsiteStore),

    sidebarComponents() {
      return this.websiteStore.sidebarComponents;
    },

    cards() {
      return this.groupedVariables.cards;
    },

    buttons() {
      return this.groupedVariables.buttons;
    },
  },

  methods: {
    handleCardClick(card: any) {
      this.processCardAction(card);
    },

    handleButtonClick(card: any) {
      this.processCardAction(card);
    },

    processCardAction(card: any) {
      const hasLink = !!card.button_link;
      const rawForm = card.guide || card.form;

      if (hasLink) {
        window.open(card.button_link, '_blank');
        return;
      }

      if (!rawForm) return;

      const formData = this.parseFormV2(rawForm);
      if (!formData) return;

      this.selectedCard = { ...card, formData };
      this.popupConfig.isActive = true;
    },

    onSlideChange() {
      if (!this.swiper) return;
      this.canPaginateBack = !this.swiper.isBeginning;
      this.canPaginateNext = !this.swiper.isEnd;
    },

    onSwiper(swiper) {
      this.swiper = swiper;
    },

    slidePrev() {
      try {
        if (this.swiper) this.swiper.slidePrev();
      } catch (error) {
        console.error('Error in slidePrev:', error);
      }
    },

    slideNext() {
      try {
        if (this.swiper) this.swiper.slideNext();
      } catch (error) {
        console.error('Error in slideNext:', error);
      }
    },
  },
});
</script>
